const appDatasetContainer=document.getElementById("app");

__webpack_public_path__ = appDatasetContainer!.dataset.origin as string ?? "https://aftersales.einhell.com/";

export const vueAppSourceUrl = __webpack_public_path__
